import { render, staticRenderFns } from "./WelcomeModal.vue?vue&type=template&id=31c6eab4&scoped=true&"
import script from "./WelcomeModal.vue?vue&type=script&lang=ts&"
export * from "./WelcomeModal.vue?vue&type=script&lang=ts&"
import style0 from "./WelcomeModal.vue?vue&type=style&index=0&id=31c6eab4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c6eab4",
  null
  
)

export default component.exports